module.exports = __webpack_public_path__ + "static/img/component.a69885f8.svg";